import { render, staticRenderFns } from "./cashbackPopup.vue?vue&type=template&id=63c470a7&scoped=true"
import script from "./cashbackPopup.vue?vue&type=script&lang=js"
export * from "./cashbackPopup.vue?vue&type=script&lang=js"
import style0 from "./cashbackPopup.vue?vue&type=style&index=0&id=63c470a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c470a7",
  null
  
)

export default component.exports